import React, { useContext } from "react";
import "./Item.css";
import { Link } from "react-router-dom";
import { CurrencyContext } from "../../Context/CurrencyContext";

const Item = (props) => {
  const { formatPrice } = useContext(CurrencyContext);
  return (
    <div className="item">
      <Link to={`/product/${props.id}`}>
        <img
          onClick={() => window.scrollTo(0, 0)}
          src={props.image}
          alt={props.name}
          loading="lazy"
        />
        <p className="item-text">{props.name}</p>
      </Link>
      <div className="item-prices">
        <div className="item-price-new">{formatPrice(props.new_price)}</div>
        <div className="item-price-old">{formatPrice(props.old_price)}</div>
      </div>
    </div>
  );
};

export default Item;
